var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "file-preview" },
    _vm._l(_vm.links, function (link, i) {
      return _c("div", { key: link.url, staticClass: "image" }, [
        !_vm.disableRemove
          ? _c(
              "button",
              {
                staticClass: "close-button",
                on: {
                  click: function ($event) {
                    return _vm.remove(i)
                  },
                },
              },
              [_c("w-fa", { attrs: { icon: "times" } })],
              1
            )
          : _vm._e(),
        _c("img", {
          staticClass: "img-preview",
          attrs: { src: link.url, alt: link.name },
        }),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }